import HorizontalValueDisplay from "./HorizontalValueDisplay/HorizontalValueDisplay"
import type { ValueDisplayProps } from "./ValueDisplay.types"
import VerticalAvatarValueDisplay from "./VerticalAvatarValueDisplay/VerticalAvatarValueDisplay"
import VerticalTextValueDisplay from "./VerticalTextValueDisplay/VerticalTextValueDisplay"

export default function ValueDisplay(props: ValueDisplayProps) {
    if (props.variant === "horizontal") {
        return <HorizontalValueDisplay {...props} />
    } else {
        if (props.valueType === "avatarGroup") {
            return <VerticalAvatarValueDisplay {...props} />
        } else {
            return <VerticalTextValueDisplay {...props} />
        }
    }
}
